export default "__VITE_ASSET__BblypN06__"